import { createApp } from 'vue';
import TheFooter from './TheFooter';
import netsetNode from 'netsetNode';

var footerInfo;

function init() {
    netsetNode.call('/nodeapi/footer_content').then(function (response) {
        footerInfo = response;
        initVue();
    });
}

function initVue() {
    const app = createApp(TheFooter, { footerInfo });
    app.mount('#footer');
}

init();
